var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLargeArrowRightFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 27 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.368 23.932 1.107 1.078 11.903-12.003L13.342 1.01l-1.1 1.085 10.178 10.15H1.378v1.537h21.05l-10.06 10.15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLargeArrowRightFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LargeArrowRightFilled.f3202ab88f6be8a8fb7f402919800c25.svg";